import { tenantSettingsSerializer } from '@/providers/serializers/tenant-settings/tenant-settings';
import {Vue} from 'vue-property-decorator';
import { http } from '../http';

export class TenantSettingsAPI extends Vue {

    public static INSTANCE = new TenantSettingsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/missioncontrol/v1';

    private categorynamespace: string = 'api/nucleus/v2/taxonomy';

    private adminNamespace: string = 'api/admin/v1';

    private adminUtils: string = 'api/v1/admin-utils';

    /**
     * fetchTenantSettings
     */
    public fetchTenantSettings(token?: any) {
        const endpoint = `${this.namespace}/tenant/settings`;
        const header = http.getTokenHeaders();

        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSettings(response.data);
        });
    }

    public fetchActiveTenantSettings(token?: any) {
            const endpoint = `api/nucleus/v1/lookups/tenant-settings`;
            const header = http.getTokenHeaders(token);
            return http.get(endpoint, header).then((response) => {
                return tenantSettingsSerializer.serializeActiveTenantSettings(response.data);
            });
    }

    public fetchTenantSettingById(tenantId: string, token?: any) {
        const endpoint = `${this.adminNamespace}/tenant/settings?tenant_id=${tenantId}`;
        const header = http.getTokenHeaders(token);
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSettingById(response.data);
        });
    }

    public fetchTenantDetails(params: any, token?: any) {
        const endpoint = `${this.adminUtils}/tenant-id`;
        const header = http.getTokenHeaders(token);
        return http.get(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    /**
     * updateTenantSettings
     */
    public updateTenantSettings(params: any) {
        const endpoint = `${this.adminNamespace}/tenant/settings`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        });
    }

    public fetchClassification() {
        const endpoint = `${this.namespace}/tx/classifications`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeClassification(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public fetchClassifications() {
        const endpoint = `${this.categorynamespace}/classifications`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTaxonomyClassifications(response.data);
        });
    }

    public fetchTenantList() {
        const endpoint = `${this.namespace}/tenants`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }


    public fetchTenantById(id: string) {
        const endpoint = `${this.namespace}/tenant/${id}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSetting(response.data);
        });
    }

    public fetchTenantKeysList() {
        const endpoint = `${window.location.origin}/settings/tenant-settings.json`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data;
        });
    }

    public fetcTenantConfigKeys() {
        const endpoint = `${this.adminNamespace}/tenant/config`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSettingByGroup(response.data);
        });
    }

    public fetcTenantConfigKeysRaw() {
        const endpoint = `${this.adminNamespace}/tenant/config`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSettingByGroupRaw(response.data);
        });
    }

    public fetcTenantConfigKeysRawList() {
        const endpoint = `${this.adminNamespace}/tenant/config`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeTenantSettingRawList(response.data);
        });
    }
    public fetchTenantDetail(tenantId: any) {
        const endpoint = `${this.adminNamespace}/tenant/${tenantId}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data;
        });
    }
    public fetchNudgesDetail(tenantId: any) {
        const endpoint = `${this.adminNamespace}/nudge/${tenantId}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data;
        });
    }
    public fetchSubscribedProductList(tenantId: any) {
        const endpoint = `${this.adminNamespace}/subscriber/${tenantId}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response;
        });
    }
}

export const tenantSettingsAPI = TenantSettingsAPI.instance;
